import { Pipe, PipeTransform } from "@angular/core";

import { MessageCodeFallbackService } from "./message-code-fallback.service";

@Pipe({ name: "messageCodeFallback" })
export class MessageCodeFallbackPipe implements PipeTransform {
	constructor(private service: MessageCodeFallbackService) {}

	transform(key: string, context: string): string {
		return this.service.get(`${context}.${key}`.toLowerCase());
	}
}
